import React, { useState } from "react";
import { Button } from "@material-ui/core";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import DialogAutoMap from "./DialogAutoMap";

export default function ButtonAutoMap({ project }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      {project && (
        <Button
          color="primary"
          onClick={() => setIsDialogOpen(true)}
          endIcon={<FlashOnIcon />}
        >
          Auto Map
        </Button>
      )}
      <DialogAutoMap
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        project={project}
      />
    </>
  );
}
